import React from 'react';
import PropTypes from 'prop-types';
import DayPickerInput from 'react-day-picker/DayPickerInput'
import _ from 'lodash';

import { getDateValue } from '../../utils/date';

function greater(v1, v2) {
  if (v1 && v2) return (v1 > v2 ? v1 : v2);
  return v1 || v2;
}

export class DateFieldFixedDateBelow extends React.Component {
  // static PropTypes = {
  //   value: PropTypes.string,
  //   limits: PropTypes.object.isRequired,
  //   isValid: PropTypes.bool,
  //   errorText: PropTypes.string,
  //   masterMode: PropTypes.bool,
  //   onChange: PropTypes.func.isRequired,
  // }

  constructor(props) {
    super(props);
    this.state = {
      isValid: true,
      saving: false,
      errorText: '',
      hasFocus: false,
      value: getDateValue(props.value)
    };
    this.setLimits(props.limits);
    this.handleChange = this.handleChange.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setLimits(nextProps.limits)
  }

  setLimits(limits) {
    this.limits = _.mapValues(limits, (v) => v && new Date(v))
  }

  getDatePickerProps(value, limits) {
    const month = limits.month || greater(limits.dateAbove, limits.dateLeft);
    const start = limits.dateAbove;
    const end = limits.dateBelow;
    const config = {};

    if (!value && month) config.month = month;
    if (this.props.masterMode) return config;

    if (start) {
      _.set(config, 'modifiers.disabled', function (day) {
        return (start && day < start);
      });
    }

    if (end) {
      _.set(config, 'modifiers.disabled', function (day) {
        return (end && day > end);
      });
    }

    // disable above and below
    if (start && end) {
      _.set(config, 'modifiers.disabled', function (day) {
        if (day < start)
          return (day < start)
        if (day > end)
          return (day > end);
      });
    }

    return config;
  }

  handleKeyDown = (event) => {
    if (this.props.disableManualEntry) {
      event.preventDefault();
    }
  };

  handleChange(day) {
    const value = day ? day.format('L') : '';
    this.props.onChange(value);
  }

  render() {
    const { value, isValid, errorText, placeholder } = this.props;
    const dayPickerProps = this.getDatePickerProps(value, this.limits)
    const tooltipClass = 'tooltip' + (this.state.hasFocus ? ' has-focus' : '')

    return (
      <div className={'date-field' + (isValid ? '' : ' has-error')}>
        <DayPickerInput
          value={getDateValue(value)}
          format="L"
          dayPickerProps={dayPickerProps}

          onDayChange={this.handleChange}
          onFocus={() => this.setState({ hasFocus: true })}
          onBlur={() => this.setState({ hasFocus: false })}
          placeholder={placeholder}

        />
        {errorText ? <div className={tooltipClass}>{errorText}</div> : null}
      </div>
    );
  }
}

DateFieldFixedDateBelow.propTypes = {
  value: PropTypes.string,
  limits: PropTypes.object.isRequired,
  isValid: PropTypes.bool,
  disableManualEntry: PropTypes.bool,
  errorText: PropTypes.string,
  masterMode: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
};